<div class="header-bar">
  <h1>Amazon Inspection</h1>
</div>

<p-tabView (onChange)="changeTab($event)" class="hideTabPanel">
  <p-tabPanel header="Site Mapping"></p-tabPanel>
  <p-tabPanel header="Deploy Jobs"></p-tabPanel>
</p-tabView>
<div *ngIf="tab == 0" class="content-container">
  <inspection-site-supplier></inspection-site-supplier>
</div>
<div *ngIf="tab == 1" class="content-container">
  <inspection-deployment></inspection-deployment>
</div>
